
<li routerLinkActive="active">
<a routerLink="/dashboard" title="Blank Project" data-filter-tags="blank page">
  <i class="{{iconPrefix}} fa-analytics"></i>
  <span class="nav-link-text" data-i18n="nav.dashboard">{{'Dashboard' | i18next}}</span>
</a>
</li>
<li routerLinkActive="active">
<a routerLink="/devices" title="Blank Project" data-filter-tags="Device page">
  <i class="{{iconPrefix}} fa-air-conditioner"></i>
  <span class="nav-link-text" data-i18n="nav.dashboard">{{'Devices' | i18next}}</span>
</a>
</li>
<li routerLinkActive="active">
<a routerLink="/control" title="Blank Project" data-filter-tags="Control page">
  <i class="{{iconPrefix}} fa-house-signal"></i>
  <span class="nav-link-text" data-i18n="nav.dashboard">{{'Control' | i18next}}</span>
</a>
</li>
<li routerLinkActive="active">
<a routerLink="/sharing" title="Sharing Devices" data-filter-tags="Control page">
  <i class="{{iconPrefix}} fa-share-alt"></i>
  <span class="nav-link-text" data-i18n="nav.dashboard">{{'Sharing' | i18next}}</span>
</a>
</li>
